import { enableProdMode } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

const url = new URL(window.location.href);
if (!!url.searchParams.has('testid-debug') && window) {
  console.log('%cTest ID debugging mode is active!', 'color:green');
  (window as any).testIdDebug = true;
  (window as any).testIdList = [];
}
if (!!url.searchParams.has('without-translate') && window) {
  console.log('%cWithout translate mode is active!', 'color:green');
  (window as any).withoutTranslate = true;
}

platformBrowser().bootstrapModule(AppModule);
